import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'

export const supportedLanguages = ['en', 'ko'] as const
export type Language = (typeof supportedLanguages)[number]

export const languageNames: Record<Language, string> = {
  en: 'English',
  ko: '한국어',
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    ns: ['navigation'],
    defaultNS: 'navigation',
    supportedLngs: supportedLanguages,
  })

export default i18n
